module.exports = __webpack_public_path__ + "static/media/onlineplatform.69eff63a.svg";